export default {
    "label.update_translations_unsuccessful": "{count} Elemente fehlgeschlagen:",
    "global.no_records": "Keine Aufzeichnungen",
    "notifications.rp_has_been_updated": "Gold-Projekt wurde aktualisiert",
    "moduleTitle.files": "Dateien",
    "label.coordinator": "Koordinator*in",
    "sidebar.translations_managment": "",
    "table.file": "Datei",
    "label.report_overview": "Überblick",
    "label.parent_agreement": "Einverständnis der Eltern (Druckversion)",
    "parentalConsent.i_consent_to_and_understand_that": "6. Ich erkläre mich damit einverstanden und verstehe, dass von Teilnehmenden, die an bestimmten Aktivitäten im Zusammenhang mit dem Award teilnehmen, Fotos gemacht werden dürfen und diese Fotos für die Bekanntmachung des Programms verwendet werden dürfen, sofern ein entsprechendes Freigabeformular sowohl vom Teilnehmenden als auch von seinen Eltern/Erziehungsberechtigten unterzeichnet wird.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Mir ist bekannt, dass die Teilnehmenden verpflichtet sind, die im Handbuch oder ORB enthaltenen Anforderungen an den Award, die Richtlinien und Verhaltensstandards des jeweiligen Award Anbieters (in der jeweils gültigen Fassung) und die Anforderungen des Award Anbieters in Bezug auf Notfallpläne, die Bewertung von Aktivitäten und die Durchführung von Expeditionen im Zusammenhang mit dem Award einzuhalten, und ich verstehe, dass der Award Anbieter Teilnehmenden bei Nichteinhaltung ihre Zustimmung zur Teilnahme am Award entziehen kann.",
    "table.end_date": "Enddatum",
    "label.activation_date": "Datum der Aktivierung",
    "label.report": "Bericht",
    "label.award_is_offline": "Award ist offline",
    "label.pending_changes": "Ausstehende Änderungen ...",
    "errors.min_nights_required": "Es sind mindestens {nights} Nächte erforderlich",
    "label.country": "Land",
    "notifications.award_leader_has_been_returned": "Award Leader wurde überarbeitet",
    "notifications.participant_has_been_updated": "Teilnehmer*in wurde aktualisiert",
    "label.phone_number": "Telefonnummer",
    "roles.aj_assessor": "Gutachter*in Expedition",
    "notifications.person_state_has_been_changed": "Personenstatus wurde verändert",
    "pageTitle.dashboard": "Dashboard",
    "moduleTitle.global_payment_method": "Globale Zahlungsmethode",
    "label.organization_type": "Organisationsart",
    "button.account_settings": "Einstellungen Konto",
    "notifications.contact_has_been_updated": "Kontakt wurde aktualisert",
    "participant.recover_password": "Passwort wiederherstellen",
    "notifications.assessment_request_has_been_sent": "Bitte um Gutachten wurde versendet",
    "button.unassign": "Aufheben der Zuweisung",
    "label.start_date": "Startdatum",
    "label.assign_labels": "Label zuweisen",
    "sidebar.participants": "Teilnehmer*innen",
    "roles.coordinator": "Koordinator*in",
    "label.organization_contact": "Organisationskontakt",
    "tabs.customization": "Personalisierung",
    "sidebar.award_units": "Award Anbieter",
    "button.change_goal": "Ziel ändern",
    "translationsManagement.selectProject": "Projekt auswählen",
    "award.rp": "Gold-Projekt",
    "label.size": "Größe",
    "label.bulk_action_results": "Bulk Aktion Ergebnisse",
    "notifications.activity_has_been_approved": "Aktivität wurde genehmigt",
    "label.payment_type": "Art der Zahlung",
    "button.gop_assignment": "GOP-Zuweisung",
    "button.resend_assessment_request": "Bitte um Gutachten erneut versenden",
    "notifications.template_has_been_removed": "Vorlage wurde entfernt",
    "button.award_settings": "Einstellungen Award",
    "pageTitle.payment": "Zahlung",
    "tasks.return_award": "Award überarbeiten",
    "label.link": "Link",
    "moduleTitle.award_participant_delete": "Einen Award Level löschen",
    "pageTitle.mro_related_contacts": "Mein regionales Büro - Verwandte Kontakte",
    "pageTitle.my_organization_labels": "Meine Organisation - Labels",
    "tabs.activity_signoff": "Programmteil",
    "table.logs": "Nachweise",
    "moduleTitle.remove_file": "Datei enfernen?",
    "label.email_confirmed": "Email bestätigt",
    "notifications.activity_has_been_returned": "Aktivität wurde überarbeitet",
    "label.note": "Notiz",
    "button.show": "Zeigen",
    "tabs.adventurous_journey": "Expedition",
    "sidebar.my_todolist": "Meine To Do Liste",
    "label.here": "hier",
    "organisation.change_award_mode": "Modus Award verändern",
    "table.note_from_al": "Notiz vom Award Leader",
    "label.gender": "Geschlecht",
    "moduleTitle.remove": "Entfernen?",
    "errors.must_be_less_than": "Muss kleiner als {limit} sein",
    "button.logout": "Logout",
    "label.no_selected_participants": "Kein*e Teilnehmende ausgewählt",
    "button.new_aj_event": "Neue Expedition",
    "label.employement_status": "Beschäftigungsstatus (optional)",
    "tabs.logs": "Nachweise",
    "tabs.contacts": "Kontakte",
    "label.option": "Option",
    "dashboard.charts": "Grafiken",
    "notifications.rp_has_been_approved": "Gold-Projekt wurde genehmigt",
    "pageTitle.new_participant": "Neue(r) Teilnehmer*in",
    "notifications.award_leader_has_been_approved": "Award Leader wurde genehmigt",
    "moduleTitle.would_you_like_to_remove_leader_training": "Möchten Sie die Fortbildung des Award Leaders löschen?",
    "moduleTitle.update_configuration_value": "Konfigurationswert aktualisieren",
    "table.description": "Beschreibung",
    "table.organization": "Organisation",
    "label.youtube": "YouTube",
    "label.author": "Autor*in",
    "table.suitable_for_award_level": "Passend für Stufe",
    "label.content_update": "Bitte warten. Inhalt wird aktualisiert...",
    "notifications.new_question_has_been_added": "Neue Frage wurde hinzugefügt",
    "pageTitle.nao_awards": "Nationales Büro - Awards",
    "table.last_name": "Nachname",
    "moduleTitle.adventurous_journey_detail": "Angaben zur Expedition",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": "Bulk Aktion"},
    "label.project_location_type": "Standortart des Gold-Projekts",
    "label.email_help_award_level": "Award Stufe",
    "label.date": "Datum",
    "label.previous_completed_award_place": "Wo",
    "button.show_more": "Mehr zeigen",
    "label.wwc_number": "WWC Nummer",
    "button.filter": "Filter",
    "notifications.rp_has_been_returned": "Gold-Projekt wurde überarbeitet",
    "pageTitle.residetial_project_assessor_report": "Gold-Projekt - Gutachten",
    "label.generating": "Erstellen...",
    "moduleTitle.finance_system_data": "Finanzsystemdaten",
    "notifications.adventurous_journey_state_has_been_changed": "Expeditionsstatus wurde geändert",
    "route.levels": "Stufen",
    "moduleTitle.activity_leader": "Anbieter Aktivität",
    "tasks.approve_event": "Expedition genehmigen",
    "tasks.reject_event": "Expedition überarbeiten",
    "table.region": "Region",
    "pageTitle.nao_award_leaders": "Nationales Büro - Award Leader",
    "errors.must_be_at_least": "Muss mindestens {min} Zeichen enthalten",
    "table.title": "Titel",
    "table.last_activity": "Letzte Aktivität",
    "tasks.delete_registration": "Anmeldung löschen",
    "table.date_time": "Ortszeit",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. Die Anbieter des Awards verpflichten sich, Ihre und die Privatsphäre der Teilnehmenden zu respektieren. Persönliche Informationen werden auf diesem Formular zum Zweck der Teilnahme am Award gesammelt. Wir können Ihre persönlichen Daten auch verwenden, um Ihnen Informationen über andere Award Aktivitäten oder Veranstaltungen zu senden, von denen wir glauben, dass sie für Sie von Interesse sein könnten. Wir können diese Informationen an andere lokale oder internationale Organisationen und Dienstleister weitergeben, die uns im Award Netzwerk bei der Durchführung und Verwaltung des Awards unterstützen. Wenn Sie mit uns Kontakt aufnehmen oder auf Ihre persönlichen Daten zugreifen möchten, schreiben Sie bitte an Ihren nationalen Trägerverein (info@dofe-germany.de). Bei ihm können Sie auch eine Kopie der Datenschutzerklärung anfordern.",
    "aj.practice_journey": "Probeexpedition",
    "notification.log_has_been_restored": "Nachweise Aktivität wiederhergestellt",
    "tabs.my_participants": "Meine Teilnehmer*innen",
    "label.bulk_action_assign_label": "Label zuweisen",
    "moduleTitle.supervisor": "Aufsichtsperson",
    "moduleTitle.your_parental_consent": "Ihr Einverständnis als Eltern",
    "route.registration_participants": "Anmeldungen Teilnehmer*innen",
    "placeholder.start_typing": "Beginne zu tippen...",
    "tasks.approve_award": "Award genehmigen",
    "route.registrations": "Anmeldungen",
    "button.add_activity": "Aktivität hinzufügen",
    "notifications.aj_event_has_been_created": "Expeditionsveranstaltung wurde erstellt",
    "states.supervisor_approval": "Genehmigung Gutachter*in",
    "label.description": "Beschreibung",
    "button.leave_anyway": "Trotzdem verlassen",
    "tabs.registrations": "Anmeldungen",
    "states.leader_signoff": "Validieren Programmteil",
    "moduleTitle.forbidden": "Nicht erlaubt",
    "notifications.translations_has_been_updated.button": "Übersetzungen erfolgreich geladen",
    "pageTitle.nao_registration": "Nationales Büro - Anmeldung",
    "pageTitle.mro_logs": "Mein regionales Büro - Nachweise",
    "meta.page_not_found": "Seite nicht gefunden",
    "label.bulk_action_unsuccessful": "{count} Elemente fehlgeschlagen",
    "global.days": "Tage",
    "table.review": "Überprüfen",
    "table.as_assessor_for": "Als Gutachter*in für",
    "roles.if_staff_statistical_user": "IAF Viewer Statistik (International Award Foundation)",
    "table.levels": "Stufen",
    "label.suitable_for_level": "Geeignet für Stufe",
    "pageTitle.leaders": "Award Leader",
    "moduleTitle.send_test_email": "Test-Email senden",
    "pageTitle.tasks_removed_registration": "Anmeldung Teilnehmer*in entfernt",
    "label.you_will_be_forced_to_login_again_after_change": "Nach der Änderung müssen Sie sich erneut anmelden\n",
    "table.recent_updates": "Anmerkungen und aktuelle Updates",
    "pageTitle.tasks_activity_signoffs": "Genehmigung Programmteil",
    "pageTitle.payments": "Zahlungen",
    "global.nights": "Nächte",
    "label.blank_any_level": "BLANK auf jeder Ebene",
    "button.view_section": "",
    "moduleTitle.select_organization": "Organisation auswählen",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Dateien hochladen",
    "label.migrated_contact_email": "Übernommene Kontakt-Email",
    "label.for_award_unit": "Für Award Anbieter",
    "label.aj_template_note": "Vorlage Notiz",
    "table.last_log_added": "Letzter Nachweis hinzugefügt",
    "button.view_participant": "Von dem/der Teilnehmenden",
    "label.please_comment_on_the_participants": "Bitte geben Sie uns eine Einschätzung des Engagements des*der Teilnehmer*in (gerne stärkenorientiert).",
    "label.consent_already_given_login": "Einverständnis bereits erteilt. Bitte melden Sie sich als Ihr Kind an.",
    "participant.level_start_date": "{value} Startdatum",
    "sidebar.my_region_office": "Mein regionales Büro",
    "states.section_signoff": "Genehmigung Programmteil",
    "moduleTitle.assessor_details": "Angaben Gutachter*in",
    "moduleTitle.adventurous_journey_settings": "Einstellungen Expedition",
    "moduleTitle.note_from_al": "Notiz vom Award Leader ",
    "button.add_role": "Rolle hinzufügen",
    "table.run": "Loslegen",
    "states.change_to_state_warning_missing_assessment": "Der:die Teilnehmende hat diesen Programmteil noch nicht an den:die Gutachter:in weitergeleitet. Trotzdem fortsetzen?",
    "label.user_app_guide_leader": "Nutzerhandbuch App - Teilnehmende - Award Leader",
    "tabs.section_approval": "Programmteil",
    "roles.award_verifier": "Award Prüfer*in (falls anwendbar)",
    "tabs.activity_approval": "Aktivität",
    "logs.add_log": "Nachweis hinzufügen",
    "tabs.award": "Award",
    "notifications.this_role_has_read_only_persmission": "Diese Rolle darf nur lesen.",
    "table.no_filtered_results": "Keine gefilterten Ergebnisse",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "Keine Begrüßungs-Email an Gutachter:in senden",
    "label.location_detail": "Angaben zum Ort",
    "label.optional": "(optional)",
    "errors.do_not_match": "Stimmt nicht überein",
    "label.use_comma_for_multiple_entries": "Verwenden Sie Kommata für mehrere Einträge",
    "label.operating_authority": "Operating Partner",
    "label.activity_section": "Programmteil",
    "notifications.you_have_been_logged_out": "Sie wurden abgemeldet",
    "table.finished": "Abgeschlossen",
    "button.same_as_billing": "Wie Rechnungsadresse",
    "table.payment": "Zahlung",
    "table.current_level": "Aktuelle Stufe",
    "button.view_nao": "Vom Verein zurückgesandt (mit einer Begleitnotiz)",
    "table.email_confirmation": "Bestätigung Email",
    "moduleTitle.shipping_address": "Lieferanschrift",
    "label.secondary_phone_type": "Sekundäre Telefonart",
    "notifications.saved": "Gespeichert",
    "pageTitle.all_participants": "Alle Teilnehmer*innen",
    "label.first_name": "Vorname",
    "label.oa_price": "OA Preis",
    "table.award_mode": "Modus Award",
    "tabs.api_keys": "API-Schlüssel",
    "award.award_detail": "Award Details",
    "tabs.user_management": "Nutzerverwaltung",
    "tabs.all_events": "Alle Expeditionen",
    "notifications.history_record_has_been_removed": "Verlaufsaufzeichnung wurde entfernt",
    "award.no_data": "Die Daten für diesen Award sind für Sie nicht sichtbar.",
    "notifications.preparation_training_has_been_added": "Vorbereitung und Ausbildung wurde hinzugefügt",
    "label.message": "Nachricht",
    "notifications.participant_info_updated": "Angaben Teilnehmer*in aktualisiert",
    "roles.nao_staff": "NAO Team",
    "tabs.adventurous_journeys": "Expeditionen",
    "label.gops": "Global Operating Partners",
    "route.upload": "Hochladen",
    "notifications.history_record_has_been_added": "Verlaufsaufzeichnung wurde hinzugefügt",
    "notifications.history_record_has_been_updated": "Verlaufsaufzeichnung wurde aktualisiert",
    "label.no_data": "KEINE INFORMATIONEN VERFÜGBAR.\nEntweder ist dieser Teil des Awards nicht eingerichtet oder Sie haben keinen Zugriff auf diese Informationen (was der Fall ist, wenn ein Teilnehmer:innen von einem anderen Programmanbieter gewechselt hat)",
    "button.add_coordinator": "Koordinator*in hinzufügen",
    "label.you_are_already_logged_as": "Sie sind bereits angemeldet als ",
    "route.my_national_office": "Mein nationales Büro (Verein)",
    "tabs.leaders": "Award Leader",
    "label.email_confirmation": "Bestätigungsemail",
    "table.registration_date": "Datum Anmeldung",
    "notifications.role_has_been_removed": "Rolle wurde entfernt",
    "button.move": "Verschieben",
    "label.terms_and_conditions": "Bedingungen und Bestimmungen",
    "pageTitle.detail": "Details",
    "table.award_unit": "Award Anbieter",
    "sidebar.settings": "Einstellungen",
    "dashboard.leader_state": "Award Leader - nach Bundesländern",
    "notifications.award_unit_has_been_approved": "Award Anbieter wurde genehmigt",
    "states.awaiting_approval": "Warten auf Genehmigung",
    "table.level": "Stufe",
    "table.action_requested": "Aktion erfolgt",
    "label.organisation_mode": "Organisationsmodus",
    "label.no_note": "Keine Nachricht",
    "tabs.my_events": "Meine Expeditionen",
    "notifications.participants_have_been_added": "Teilnehmer*innen wurden hinzugefügt",
    "tabs.registration_questions": "Regionale Fragen",
    "button.delete_registration": "Anmeldung löschen",
    "notifications.parental_consent_link_has_been_sent": "Link zum Einverständnis der Eltern wurde erneut versendet",
    "moduleTitle.select_role_organization": "Rolle & Organisation auswählen",
    "label.experience": "Erfahrung",
    "translationsManagement.modal.title": "Möchten Sie Übersetzungen aktualisieren?",
    "table.ic": "Unabhängiges Land",
    "table.id": "ID",
    "label.notify_email_explanation": "Die Teilnehmer:innen werden per E-Mail benachrichtigt, dass ihre Begutachtungsanfrage nicht zugestellt wurde, und werden aufgefordert, die E-Mail zu korrigieren und die Begutachtung erneut zu beantragen.",
    "participant.would_you_like_to_remove": "Möchtest du dieses Konto löschen?",
    "table.fields_included": "Enthaltene Felder",
    "label.user_guide_web_leader": "Nutzerhandbuch Web - Award Leader",
    "label.journey_type": "Art der Expedition",
    "button.setup": "Setup",
    "tabs.my_national_office": "Mein nationales Büro (Verein)",
    "notifications.training_has_been_removed": "Ausbildung wurde entfernt",
    "label.nominated_and_identified_persons": "Ausgewählte Personen, die alle Daten sehen, aber nicht bearbeiten dürfen",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Sie wurden aufgrund von Inaktivität abgemeldet",
    "states.award_leader_signoff": "Genehmigung Award Leader",
    "table.award_signoff_attempts": "Anzahl Versuche, Award zu genehmigen",
    "sidebar.regions": "Regionen",
    "label.activity_deleted_note": "Ihre Aktivität wurde gelöscht. Zum Wiederherstellen auf die untere Schaltfläche klicken.",
    "table.total": "Gesamt",
    "errors.a_problem_has_occured_during_processing": "Während der Verarbeitung ist ein Problem aufgetreten. Weitere Informationen finden Sie hier",
    "participant.participant_already_has_gold_award": "Teilnehmer*in hat bereits einen Gold Award ",
    "pageTitle.mro": "Mein regionales Büro",
    "notifications.authorization_code_has_expired": "Autorisierungscode ist abgelaufen",
    "moduleTitle.child_organization_labels": "Label für Kinderorganisationen",
    "aj.aj_events": "Expeditionen",
    "global.loading": "Lädt",
    "label.gnipp": "",
    "sidebar.registrations": "Anmeldungen",
    "label.any_string": "Any string",
    "contact.change_contact_status": "Status Kontakt ändern",
    "tabs.registration": "Anmeldung",
    "label.override_payment_note": "Zahlungsbeleg überschreiben",
    "notifications.section_has_been_signed_off": "Programmteil wurde genehmigt",
    "label.payment_date": "Datum der Zahlung, falls erfolgt",
    "button.approve": "Genehmigen",
    "moduleTitle.loggin_in": "Anmelden",
    "label.website": "Webseite",
    "label.role": "Rolle",
    "table.assessor_report": "Bericht Gutachter*in",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "Bitte geben Sie eine Rückmeldung, wie der:die Teilnehmer:in auf das Ziel der Aktivität hingearbeitet hat",
    "label.previously_worked_as_assessor": "Zuvor als Gutachter*in tätig",
    "pageTitle.registrations": "Anmeldungen",
    "parentalConsent.this_form_must_be_completed": "Teilnehmer*innen unter 18 Jahren benötigen dieses von ihren Eltern/Erziehungsberechtigten unterzeichnete Formular.",
    "button.apply": "",
    "errors.include_at_least_one_number": "Mindestens eine Ziffer\n",
    "label.content_restore": "Sitzung aktualisieren...",
    "logs.hour": "Stunde",
    "parentalConsent.i_have_read_and_understand": "7. Ich habe die verschiedenen Stufen und Anforderungen des Awards gelesen und verstanden, wie sie in der Gliederung des Awards (Seite 5 dieses Formulars) dargelegt sind.",
    "notifications.award_was_deleted": "Der Award wurde gelöscht.",
    "label.journey_category": "Art der Expedition",
    "notifications.search_cancelled": "Die Suche wurde unterbrochen. Sie müssen warten, bis die Suche abgeschlossen ist.",
    "route.detail": "Angaben",
    "route.user_guide": "Nutzerhandbuch",
    "moduleTitle.history": "Verlauf",
    "table.gop_name": "Global Operating Partner\n",
    "pageTitle.tasks_unassigned_participants": "Nicht zugewiesene Teilnehmer*innen",
    "states.inactive": "Archiv",
    "pageTitle.search_results": "Suchergebnisse",
    "button.proceed_to_login": "Zur Anmeldung",
    "pageTitle.assessor_report_reject": "Überarbeitung Gutachten",
    "notifications.contact_has_been_removed": "Kontakt wurde entfernt",
    "sidebar.operating_authorities": "Operative Partner",
    "label.no_note_from_participant": "Keine Notiz des:der Teilnehmenden",
    "aj.preparation_and_training": "Vorbereitung und Ausbildung",
    "route.user_guide_web_leader": "Nutzerhandbuch Web - Award Leader",
    "label.position_in_organization": "Position in Organisation",
    "errors.emails_dont_match": "Emailadressen stimmen nicht überein",
    "route.my_participants": "Meine Teilnehmer*innen",
    "pageTitle.customisations": "Personalisierungen",
    "tabs.localization_files": "Lokalisierungsdateien",
    "table.assessor_approval": "Genehmigung Gutachter*in",
    "tabs.related_contacts": "Verwandte Kontakte ",
    "table.aus": "Award Anbieter",
    "table.category": "Kategorie",
    "errors.file_is_too_large": "Maximale Upload-Größe ist 20MB",
    "label.possible_values": "Mögliche Werte:",
    "label.if_your_download_doesnt_start": "Wenn Ihr Download nicht automatisch startet, klicken Sie bitte hier",
    "route.independent_award_centres": "Unabhängige Award Anbieter ",
    "pageTitle.user_guide": "Nutzerhandbücher",
    "button.visit": "Besuchen",
    "label.hours_first_letter": "Stunden",
    "pageTitle.my_organization_detail": "Meine Organisaiton - Detail",
    "pageTitle.nao_detail": "Nationales Büro - Angaben",
    "button.change": "Ändern",
    "award.aj": "Expedition",
    "table.award_state": "Status Award",
    "pageTitle.tasks_award_signoff": "Genehmigung Award",
    "pageTitle.regions": "Regionen",
    "notifications.award_has_been_signed_off": "Award wurde genehmigt",
    "dashboard.award_approved_by": "Genehmigte Awards - nach Stufen",
    "tabs.new_template": "Neue Vorlage",
    "error.parent_email_must_be_filled": "Email der Eltern muss ausgefüllt werden",
    "label.organisation_invoicing_name": "Name des Lizenznehmers",
    "pageTitle.related_contacts": "Verwandte Kontakte",
    "button.try_again": "Warnung schließen und erneut versuchen",
    "label.cannot_be_change_to_another": "Kann nicht zu einer anderen Stufe geändert werden",
    "notifications.lead_coordinator_has_been_set": "Neue*r Hauptkoordinator*in wurde festgelegt",
    "label.training_name": "Ausbildung Bezeichnung",
    "moduleTitle.new_contact": "Neuer Kontakt",
    "translationsManagement.modal.updateTitle": "Sind Sie sicher?",
    "moduleTitle.offline_award_units_signoff": "Offline Award Leader Genehmigung",
    "notifications.award_level_has_been_changed": "Award Stufe wurde verändert",
    "label.subject": "Betreff",
    "route.silver_level": "Silber Stufe",
    "label.privacy_notice": "Datenschutzerklärung",
    "label.switch_organization": "Organisation wechseln",
    "meta.dofe_name": "Der Duke of Edinburgh’s International Award",
    "route.profile": "Profil",
    "roles.super_user": "Super-Nutzer*in",
    "dashboard.while_you_were_gone": "In Ihrer Abwesenheit",
    "label.no_note_from_award_leader": "Vom Verein zurückgeschickt (ohne Überarbeitungsnotiz)",
    "label.middle_name": "Mittlerer Name",
    "moduleTitle.new_activity": "Neue Aktivität",
    "organisation.would_you_like_to_remove": "Möchten Sie diese Organisation entfernen?",
    "label.state_province": "Bundesland",
    "moduleTitle.your_home_address": "Private Anschrift",
    "tabs.sign_offs": "Genehmigungen",
    "moduleTitle.logs": "Nachweise",
    "button.view_more": "Mehr sehen",
    "label.profile": "Profil",
    "label.title": "Anrede",
    "tabs.award_signoff": "Award",
    "label.post_code": "Postleitzahl",
    "states.ceremony_certificate": "Verleihungsfeier",
    "label.code": "Betreiber-Referenz",
    "parentalConsent.i_consent_to_the_provision_of_any": "13. Ich stimme der Weitergabe meiner persönlichen Daten (einschließlich der Teilnehmerdaten) an die Anbieterstelle und den Award Anbieter zu. Ich stimme zu, dass diese Informationen in Übereinstimmung mit den Bestimmungen der DGSVO und allen anderen Datenschutzgesetzen, -standards, -richtlinien oder -anweisungen behandelt werden, die gemäß der Datenschutzgesetzgebung für sie bindend sind.",
    "label.user_guide_web_participant": "Nutzerhandbuch Web - Teilnehmende",
    "label.award_unit_type": "Art des Award Anbieters",
    "states.complete": "Vollständig",
    "table.participant_state": "Status Teilnehmende",
    "pageTitle.my_organization_payment": "Meine Organisation - Zahlung",
    "table.approved": "Genehmigt",
    "pageTitle.my_organization_contacts": "Meine Organisation - Kontakte",
    "warning.award_marked_as_paid_registration": "Achtung: Diese:r Teilnehmer:in hat die Teilnahmegebühr bereits bezahlt. Bitte beachten Sie die Richtlinien für Erstattungen, bevor Sie bestätigen.",
    "states.change_to_state": "Wechseln zu <strong>{state}</strong>",
    "label.integer": "Ganze Zahl",
    "notifications.translationUpdateInterrupted": "Aktualisierung unterbrochen",
    "notifications.password_has_been_changed": "Passwort wurde verändert",
    "button.invite_assessor": "Gutachter*in einladen",
    "label.other_activity": "Andere Aktivität",
    "notifications.parental_consent_has_been_sent": "Einverständniserklärung der Eltern wurde versendet",
    "button.revise": "Überarbeiten",
    "errors.end_date_must_be_after_start_date": "Enddatum muss nach Startdatum liegen",
    "label.award_leader_signoff_date": "Datum Genehmigung Award Leader",
    "parentalConsent.i_understand_every_participant_must": "8. Ich verstehe, dass jede(r) Teilnehmende am Award über einen Programmanbieter teilnehmen muss, der nach eigenem Ermessen Teilnehmende und vorgeschlagene Aktivitäten, die als Teil des Awards durchgeführt werden sollen, annehmen oder ablehnen kann.",
    "moduleTitle.policies": "Richtlinien",
    "pageTitle.tasks_aj": "Expedition",
    "global.day": "Tag",
    "moduleTitle.coordinator": "Koordinator*in",
    "label.region": "Region",
    "button.add_history_record": "Verlaufsaufzeichnung hinzufügen",
    "moduleTitle.adventurous_journey_template_settings": "Einstellungen Expeditionsvorlagen",
    "notifications.personal_details_have_been_updated": "Angaben zur Person wurden aktualisiert",
    "sidebar.ics": "Unabhängige Länder",
    "table.independent_award_centre": "Unabhängiger Award Anbieter ",
    "label.undelivered_mail_reason": "Grund für Nicht-Zustellung der Email",
    "table.utc_date_time": "UTC-Zeit",
    "moduleTitle.emails": "Emails",
    "label.backoffice": "Backoffice",
    "moduleTitle.parent_consent": "Einverständnis Eltern/Erziehungsberechtigte",
    "label.photo_consent_given": "Teilnehmer*in erklärt sich damit einverstanden, dass sein*ihr Profilbild verwendet werden darf, um das Programm bekannt zu machen.",
    "moduleTitle.authorising_contact": "Autorisierender Kontakt",
    "label.assessment_with_role": "{role} Gutachten",
    "dashboard.type_of_awards": "Art des Award Anbieters",
    "moduleTitle.payment": "Zahlung",
    "states.in_progress": "In Umsetzung",
    "logs.no_logs": "Keine Nachweise",
    "sidebar.my_office": "Mein Award Büro",
    "label.assessor_report": "Bericht Gutachter*in",
    "notifications.rp_has_been_signed_off": "Gold-Projekt wurde abgenommen",
    "tabs.labels": "Label",
    "sidebar.payments": "Zahlungen",
    "meta.profile_questions": "Profilfragen",
    "label.fax": "Fax",
    "label.email_help_custom_link": "Benutzerdefinierter Link, falls eingestellt.",
    "label.last_name": "Nachname",
    "organisation.manage_gop": "Verwalten Sie Global Operating Partner",
    "table.parental_consent": "Einverständnis der Eltern",
    "dashboard.participant_by_level": "Teilnehmer*innen - nach Stufen",
    "tabs.award_leaders": "Award Leader",
    "label.i_confirm_that_ive_witnessed": "Ich bestätige, dass ich die Nachweise des/der Teilnehmer*in für die folgenden Aktivitäten gesehen habe.",
    "table.lead_coordinator": "Hauptkoordinator*in",
    "states.deleted": "Gelöscht",
    "label.no_answers": "Keine Antworten",
    "button.add": "Hinzufügen",
    "label.exchequer_number": "",
    "label.waiting": "Warten",
    "label.email_help_person_full_name": "Vollständiger Name der Person",
    "tasks.return_registration": "Anmeldung überarbeiten",
    "notifications.state_aj_preparation_training_has_been_changed": "Der Status von Adventure Journey Preparation & training wurde geändert.",
    "label.parent_approval": "Einverständnis der Eltern",
    "table.assessor_approve": "Genehmigung Gutachter*in",
    "errors.some_fields_requires_your_attention": "Einige Felder erfordern Ihre Aufmerksamkeit",
    "aj.qualifying_journey": "Abschlussexpedition",
    "route.awards": "Awards",
    "table.registration": "Anmeldung",
    "pageTitle.assessors": "Gutachter*innen",
    "notifications.award_has_been_updated": "Award wurde aktualisiert",
    "errors.must_be_one_of": "Muss eine der folgenden sein: {enums}",
    "pageTitle.logs": "Nachweise",
    "notifications.notifications.invitation_has_been_sent": "Einladung wurde versendet",
    "route.national_offices": "Nationale Büros",
    "notifications.training_has_been_updated": "Ausbildung wurde aktualisiert",
    "label.parent_last_name": "Nachname Eltern / Erziehungsberechtigte",
    "table.leaders": "Award Leader",
    "states.award_level_complete": "Stufe abgeschlossen\n",
    "button.reset": "Zurücksetzen",
    "sidebar.my_award_unit": "Mein Award Anbieter",
    "pageTitle.all_aj_events": "Alle Expeditionsveranstaltungen",
    "label.activity": "Aktivität",
    "moduleTitle.are_you_sure": "Sind Sie sicher?",
    "route.gold_level": "Gold Stufe",
    "table.evidence": "Nachweis",
    "label.delivery_confirmed": "Abgabe bestätigt",
    "parentalConsent.as_the_parent": "Als Elternteil/Erziehungsberechtigte(r) gebe ich mein Einverständnis, dass Bilder meines Kindes verwendet werden dürfen, um den Duke bekannt zu machen.",
    "label.awardMode.offline": "Offline",
    "tasks.approve_registration": "Anmeldung genehmigen",
    "note.change_the_email_will_change": "Notiz: Durch Ändern der E-Mail wird auch die übernommene Kontakt-Email geändert",
    "notifications.participant_has_been_approved": "Teilnehmer*in wurde genehmigt",
    "label.reached_activity_limit": "Höchstanzahl für Aktivitäten in diesem Programmteil erreicht. Teilnehmer*in kann maximal 3 Aktivitäten in jedem Programmteil haben.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "Das Label wurde aktualisiert.",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Vorbereitung und Ausbildung wurde hinzugefügt",
    "pageTitle.settings": "Einstellungen",
    "participant.level_registration_date": "{value} Anmeldedatum",
    "notifications.question_has_been_removed": "Frage wurde entfernt",
    "label.email_help_award_leader_full_name": "Nachname Award Leader",
    "sidebar.leaders": "Award Leader",
    "notifications.participants_have_been_transferred": "Teilnehmer*innen wurden übertragen",
    "tabs.assessors": "Gutachter*innen",
    "sidebar.dashboard": "Dashboard",
    "pageTitle.independent_award_centers": "Unabhängige Award Anbieter",
    "label.search": "Suchen",
    "moduleTitle.office_labels": "Büro-labels",
    "label.note_from_participant": "Nachricht von Teilnehmer*in",
    "errors.required_field": "Pflichtfeld",
    "tasks.approve_task": "Aufgabe genehmigen",
    "logs.edit_log": "Nachweis bearbeiten",
    "table.state": "Status",
    "moduleTitle.level_summary": "Stufenübersicht",
    "moduleTitle.guides": "Leitfäden",
    "modal.close": "Schließen",
    "label.parent_first_name": "Vorname Eltern / Erziehungsberechtigte",
    "parentalConsent.i_understand_that_the_participant": "1. Mir ist bekannt, dass der/die Teilnehmer*in erst dann an dem Programm teilnehmen kann, wenn dieses Formular ausgefüllt (inkl. Einverständniserklärung der Erziehungsberechtigten) und mit der entsprechenden Anmeldegebühr an den jeweiligen Programmanbieter zurückgeschickt und von diesem akzeptiert wurde.",
    "tabs.award_units": "Award Anbieter",
    "table.hours": "Stunden",
    "label.type": "Art",
    "notifications.adventurous_journey_has_been_removed": "Expedition wurde entfernt",
    "label.aj_is_not_approved_yet": "Expedition wurde noch nicht genehmigt",
    "roles.authorizing_contact": "Autorisierender Kontakt ",
    "table.date_submitted_to_office_signoff": "Datum Eingereicht von Teilnehmer:in / zurückgeschickt vom Award-Büro",
    "notifications.section_has_been_returned": "Programmteil wurde überarbeitet",
    "table.created_by": "Erstellt von",
    "route.user_guide_web_participant": "Nutzerhandbuch Web - Teilnehmende",
    "route.templates": "Vorlagen",
    "states.awaiting_sign_off": "Genehmigung Award Leader",
    "table.phone": "Telefon",
    "label.parental_consent": "Einverständnis Eltern",
    "label.org_contact_will_be_deleted": "Sie entfernen die letzte Rolle, die dieser Kontakt in dieser Organisation innehat. Möchten Sie die persönlichen Daten des Kontakts beibehalten oder möchten Sie den Kontakt vollständig aus dieser Organisation entfernen?",
    "route.bronze_level": "Bronze Stufe",
    "label.invoice_currency": "Rechnungswährung",
    "button.new_label": "Neues Label",
    "error.server_cannot_be_reached_at_the_moment": "Der Server ist momentan nicht erreichbar. Bitte versuchen Sie es später noch einmal. Danke für Ihr Verständnis.\n",
    "notifications.contact_has_been_created": "Kontakt wurde erstellt",
    "pageTitle.profile_questions": "Profilfragen",
    "table.observation_files": "Beobachtungsdateien",
    "table.participants": "Teilnehmer*innen",
    "tasks.no_evidence": "Keine Nachweise vorgelegt",
    "button.edit": "Bearbeiten",
    "moduleTitle.leader": "Award Leader",
    "notifications.new_template_has_been_updated": "Neue Vorlage wurde aktualisiert",
    "table.name": "Name",
    "label.no_results": "Keine Ergebnisse",
    "moduleTitle.documents": "Dokumente",
    "button.invite": "Einladen",
    "label.goal": "Ziel",
    "pageTitle.nao_award_units": "Nationales Büro - Award Anbieter",
    "label.award_delete_participant_id": "Teilnehmer:innen ID",
    "errors.at_least_num_characters": "Mindestens {length} Zeichen lang",
    "label.email_help_note": "Benutzerdefinierte Notiz, falls eingestellt.",
    "label.person_status.activating": "label.person_status.activating",
    "moduleTitle.remove_role": "Rolle entfernen?",
    "label.total": "Gesamt",
    "label.delete_participant_award_info": "DIESE AKTION IST NICHT UMKEHRBAR. BITTE ÜBERPRÜFEN SIE NOCH EINMAL, OB DIE VON IHNEN EINGEGEBENEN DATEN KORREKT SIND.\nSie sind im Begriff, einen Award Level zu löschen.  Bitte beachten Sie, dass:\na) Der Teilnehmer:in muss mehr als eine Programmstufe haben \nb) Die Hauptaktivität wird zurückgesetzt, wenn sie zu dem Award Level gehört, den Sie gerade löschen wollen. \nc) Wenn nach dem Löschen zwei Awards übrig bleiben, wird die Hauptaktivität auf den niedrigeren Award Level gesetzt, wenn er sich nicht in einem der Status Award Authorisation/ Complete/Ceremony befindet.",
    "route.leaders": "Award Leader",
    "table.start_date": "Startdatum",
    "moduleTitle.coordinators": "Koordinator*innen",
    "button.create": "Erstellen",
    "tabs.awards": "Awards",
    "parentalConsent.form_has_been_sent": "Einverständnis der Eltern wurde gesendet.",
    "states.journey_approval": "Genehmigung Expedition",
    "pageTitle.reports": "Berichte",
    "table.journey_type": "Art der Expedition",
    "label.yes": "Ja",
    "pageTitle.assessor_report": "Gutachten\n",
    "label.organization": "Anbieter",
    "notifications.award_leader_has_been_updated": "Award Leader wurde aktualisiert",
    "moduleTitle.edit_role": "Rolle bearbeiten",
    "table.journey_activity": "Aktivität Expedition",
    "label.location": "Ort",
    "label.update_translations_error_item": " Update Übersetzung fehlgeschlagen für: {language}, Code: {localeCode}, Projekt: {projectCode} weil",
    "pageTitle.adventurous_journeys": "Expeditionen",
    "global.assessor": "Gutachter*in",
    "moduleTitle.profile_questions": "Profilfragen",
    "activity.cannot_edit_activity_if_award_in_state": "Aktivität kann nicht bearbeitet werden, wenn sich die Auszeichnung im Status {state} befindet",
    "moduleTitle.assessor_detail": "Angaben Gutachter*in",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Mir ist bekannt, dass der/die Teilnehmende nach Annahme des Awards durch den zuständigen Programmanbieter ein Begleitheft oder Zugang zum Online Record Book (ORB) erhält. Der/die Teilnehmende wird sich über die Anforderungen des Awards vor Beginn der Aktivitäten im Zusammenhang mit dem Award informieren (über den Award Leader des zuständigen Programmanbieters und die Webseite). Mir ist bekannt, dass es im Ermessen des Programmanbieters liegt, zu entscheiden, ob die Award Anforderungen erfüllt sind und daher ein Bronze-, Silber- oder Gold-Award vergeben werden kann. Mir ist bekannt, dass die Verantwortung für Unfall- und Haftpflichtversicherung beim Teilnehmenden bzw. bei seinen Eltern/Erziehungsberechtigten liegt.",
    "notifications.award_has_been_returned": "Award wurde überarbeitet\n",
    "label.code_of_conduct": "Verhaltenskodex",
    "button.new_contact": "Neuer Kontakt",
    "tabs.payments": "Zahlungen",
    "roles.naa_oa_staff": "NAO",
    "label.switch_organisation_hint": "Sie können diesen Dialog jederzeit öffnen, indem Sie im Menü oben rechts die Option \"Organisation wechseln\" auswählen",
    "label.expiration_date": "Ablaufdatum",
    "tabs.participants": "Teilnehmer*innen",
    "table.practice": "Probe",
    "notifications.one_activity_has_to_remain": "Eine Aktivität im Programmteil muss aktiv bleiben",
    "label.qualifications": "Qualifikationen",
    "states.organization_approval": "Genehmigung Award Büro",
    "errors.must_be_an_integer": "Muss eine ganze Zahl sein",
    "participant.send_confirmation_email_again_question": "Bestätigungsemail erneut versenden?",
    "button.dismiss": "OK",
    "table.advice": "Hinweis",
    "label.years_of_working_experience": "Jahre der Berufserfahrung",
    "notifications.search_failed": "Beim Suchen ist ein Fehler aufgetreten. Bitte versuchen Sie es später noch einmal.",
    "notifications.changes_have_been_saved": "Änderungen wurden gespeichert",
    "moduleTitle.resend_parental_consent_link": "Link zum Einverständnis der Eltern erneut versenden?",
    "label.activity_type": "Art der Aktivität",
    "label.change_award": "Award Stufe ändern",
    "label.email": "Email",
    "button.remove": "Entfernen",
    "button.download": "Herunterladen",
    "label.vat_treatment": "USt (wenn anwendbar)",
    "pageTitle.aj_template_new": "Vorlage neue Expedition",
    "table.per_page": "Pro Seite",
    "notifications.translations_has_been_updated": "Übersetzungen wurden aktualisiert",
    "notification.award_mode_has_been_updated": "Award Modus wurde aktualisiert",
    "tasks.revise_item": "Element überarbeiten",
    "button.resend_parental_consent": "Einverständniserklärung Eltern erneut versenden",
    "table.weeks_completed_required": "Abgeschlossene/erforderliche Wochen",
    "label.last_modified": "Zuletzt geändert",
    "table.major": "Schwerpunkt",
    "label.vat_number": "USt (wenn anwendbar)",
    "errors.passwords_dont_match": "Passwörter stimmen nicht überein",
    "table.country": "Land",
    "sidebar.guides_and_policies": "Leitfäden und Richtlinien",
    "notifications.question_has_been_updated": "Frage wurde aktualisiert",
    "table.participant_name": "Name Teilnehmer:in",
    "label.registration_approval_date": "Datum der Genehmigung der Anmeldung",
    "notifications.auth_code_is_no_longer_valid": "Autorisierungscode ist nicht mehr gültig",
    "errors.must_be_no_more_than": "Darf nicht mehr als {max} Zeichen enthalten",
    "notifications.event_has_been_rejected": "Expeditionsveranstaltung wurde überarbeitet",
    "tabs.customizations": "Personalisierungen",
    "label.name_organization": "Name",
    "button.add_log": "Nachweis hinzufügen",
    "moduleTitle.invite_assessor": "Gutachter*in einladen",
    "label.resend_confirmation_email": "Bestätigungsmail erneut senden",
    "text.all_participants_will_be_transfered": "Alle Teilnehmer*innen werden einem neuen Award Leader zugewiesen",
    "label.repeat_email": "Email wiederholen",
    "errors.email_or_phone_required": "Email oder Telefonnummer ist notwendig",
    "notifications.role_has_been_updated": "Rolle wurde aktualisiert",
    "roles.if_staff_stat_user": "Nutzer Statistik",
    "participant.delete_account": "Kontakt löschen",
    "moduleTitle.would_you_like_to_remove_this_log": "Wollen Sie diesen Nachweis löschen?",
    "sidebar.sgops": "SGOPs",
    "label.prepare_new_email": "Neue E-Mail vorbereiten",
    "table.journey_category": "Art der Expedition",
    "sidebar.manual_data_import": "Manueller Datenimport",
    "label.created_after_date": "Erstellt nach",
    "route.my_organization": "Meine Organisation",
    "button.show_list": "",
    "label.leaders": "Award Leader",
    "notifications.log_has_been_modified": "Nachweis wurde verändert",
    "button.upload_file": "Datei hochladen",
    "moduleTitle.which_section_do_you_want_to": "Welchen Abschnitt möchten Sie zu \"In Bearbeitung\" zurücksetzen?",
    "tabs.bronze_level": "Bronze Stufe",
    "notifications.participants_have_been_saved": "Teilnehmer*innen wurden gespeichert",
    "pageTitle.aj_template_detail": "Expedition",
    "label.parent_email": "Email Eltern / Erziehungsberechtigte",
    "map.appr_location": "Ungefähre Adresse:",
    "notifications.log_has_been_removed": "Nachweis wurde entfernt",
    "notifications.label_has_been_assigned": "Das Label wurde zugewiesen.",
    "pageTitle.tasks_undelivered_emails": "Nichtzugestellte Emails",
    "button.stay": "Bleiben",
    "table.previous_level": "Vorherige Stufe",
    "label.award_start_date": "Startdatum Award",
    "assessor_report.returned_to_participant": "An Teilnehmer*in zurückgeschicht",
    "pageTitle.tasks_assessors_registration": "Anmeldung Gutachter*in",
    "aj.cannot_modify_award": "Die Award-Stufe kann nicht modifiziert werden, wenn Teilnehmer*innen einer Expedition zugewiesen sind",
    "moduleTitle.lost_internet_connection": "Sie haben anscheinend die Internetverbindung verloren",
    "states.ceremony": "Verleihungsfeier",
    "participant.reactivate_account": "Konto reaktivieren",
    "label.birthdate": "Geburtsdatum",
    "pageTitle.assessment_send_successfully": "Gutachten erfolgreich versendet",
    "states.assessor_approval": "Genehmigung Gutachter*in",
    "award.change_award_level": "Award Stufe ändern",
    "label.url_no_longer_valid": "Diese URL ist nicht mehr gültig.",
    "button.update": "Aktualisieren",
    "label.secondary_email": "Sekundäre Email",
    "button.role_edit": "Bearbeiten",
    "table.award_leader": "Award Leader",
    "label.level": "Stufe",
    "tasks.evidence": "Nachweis",
    "notifications.participant_is_already_in_list": "Teilnehmer*in ist bereits in der Liste",
    "button.clear": "Löschen",
    "label.allow_log_after_25_yoa": "Hinzufügen von Einträgen über dem Alter von 25 Jahren erlauben",
    "states.setup": "Setup",
    "table.activity": "Aktivität",
    "label.copy_to_clipboard": " {Text} wurde in die Zwischenablage kopiert.",
    "route.award_units": "Award Anbieter",
    "button.upload_photo": "Bild hochladen",
    "table.hours_completed_required": "Erledigt/offen",
    "table.first_name": "Vorname",
    "notifications.adventurous_journey_has_been_returned": "Expedition wurde überarbeitet",
    "pageTitle.national_offices": "Nationales Büro (Verein)",
    "notifications.you_have_been_logged_in": "Sie wurden angemeldet",
    "logs.offline": "Offline",
    "moduleTitle.add_role": "Rolle hinzufügen",
    "label.user_app_guide_participant": "Nutzerhandbuch App - Teilnehmende",
    "notifications.file_has_been_removed": "Datei wurde entfernt",
    "label.send_message": "",
    "button.select": "Auswählen",
    "label.reason_of_deletion": "Grund für die Löschung",
    "label.user_guide": "Nutzerhandbuch",
    "pageTitle.nao_participants": "Nationales Büro - Teilnehmer*innen",
    "tabs.sub_operating_partners": "Sub-Operating Partner",
    "table.uploaded_by": "Hochgeladen von",
    "tasks.approve_item": "Element genehmigen",
    "tasks.restore_participant_registration": "Anmeldung Teilnehmer*in wiederherstellen?",
    "label.awardMode.hybrid": "Hybrid\n",
    "table.first_activity_started": "Erste Aktivität begonnen",
    "moduleTitle.dates": "Termine",
    "table.no_results": "Keine Ergebnisse",
    "states.registration_approval": "Genehmigung Anmeldung",
    "table.breakdown_of_hours": "Aufschlüsselung der Stunden",
    "pageTitle.tasks_registration": "Anmeldung Teilnehmer*innen",
    "button.create_new": "Neu erstellen",
    "sidebar.todolist": "To Do Liste",
    "label.active_participants": "Aktive Teilnehmer*innen",
    "moduleTitle.postalAddress": "moduleTitle.postalAddress",
    "tasks.return_task": "Aufgabe überarbeiten",
    "organisation.change_organisation_state": "Status Organisation ändern",
    "moduleTitle.roles": "Rollen",
    "label.no_config_key_available": "Für diesen Abschnitt sind keine Konfigurationsschlüssel verfügbar",
    "placeholder.selectLanguage": "Sprache auswählen",
    "states.office_signoff": "Genehmigung Award Büro",
    "notifications.translations_has_been_updated.failure": "Aktualisierung der Übersetzung fehlgeschlagen",
    "logs.minute": "Minute",
    "label.last_activity": "Letzte Aktvität",
    "sidebar.user_guide": "Nutzerhandbücher",
    "label.trained_award_leader": "ein ausgebildeter Award Leader",
    "table.progress": "Fortschritt",
    "table.suboperating_authorities": "Sub-Operating Authorities",
    "activity.cannot_edit_activity_offline": "Dieser Teilnehmer arbeitet im Offline-Modus. <br> <br>\nSie können nicht bearbeiten; Aktivität, Expedition oder Gold Projekt, wenn sich der Award im Semi-Offline-Modus befindet.",
    "label.user_does_not_have_permissions": "Nutzer*in <strong>{user}</strong> hat keine Berechtigung, diesen Inhalt zu sehen.",
    "notifications.assessor_has_been_approved": "Gutachter*in wurde genehmigt",
    "route.activity_approval": "Genehmigung Aktivität",
    "moduleTitle.role": "Rolle",
    "button.run": "Loslegen",
    "label.to": "An",
    "notifications.file_has_been_updated": "Datei wurde aktualisiert",
    "moduleTitle.edit_coordinator": "Koordinator*in bearbeiten",
    "notifications.authorization_code_is_no_longer_valid": "Autorisierungscode ist nicht mehr gültig",
    "button.reject": "Überarbeiten",
    "label.label.participant_status": "Status Teilnehmer*in",
    "award.gold_level": "Gold Stufe",
    "sidebar.variables": "Variablen",
    "parentalConsent.checkbox_copy": "Ich bestätige, dass ich der/die Erziehungsberechtigte von {Vorname} {Nachname} bin. Ich gebe mein Einverständnis, dass er/sie am Programm in {organisationName} unter Aufsicht eines geschulten Award Leaders teilnehmen darf. Ich habe die Voraussetzungen und Bedingungen für die Teilnahme am Programm, wie oben und auf der Website des Veranstalters beschrieben, gelesen und verstanden und bin damit einverstanden.\n",
    "button.go_to_dashboard": "Gehe zu Dashboard",
    "button.add_option": "Option hinzufügen",
    "label.is_completed": "Abgeschlossen",
    "pageTitle.award_units": "Award Anbieter",
    "states.completed": "Abgeschlossen",
    "button.adventurous_journey_template_settings": "Einstellungen Expeditionsvorlagen",
    "label.system_rights": "Systemrechte",
    "label.assessor_assesstment_award_start_date": "Genehmigung Award Startdatum",
    "label.update_translation_question": "Die Übersetzungen für alle bestehenden Sprachen für ausgewählte Projekte werden aktualisiert",
    "button.login": "Login",
    "label.name_of_the_unit": "Name Anbieterstelle",
    "button.send": "Senden",
    "award.ajs": "Expeditionen",
    "meta.payments_expired": "Zahlungen - Abgelaufen",
    "label.age": "Alter",
    "notifications.payment_info_updated": "Zahlungsdaten aktualisiert",
    "table.is_completed": "Abgeschlossen",
    "table.invited_by": "Eingeladen von",
    "route.files": "Dateien",
    "route.assessors": "Gutachter*innen",
    "info.aj_supervisor_is_mandatory": "Für die Probeexpedition erhält die Aufsichtsperson, für die Abschlussexpedition der:die Gutachter:in den Antrag auf Begutachtung.",
    "pageTitle.my_participants": "Meine Teilnehmer*innen",
    "label.change_leader_status": "Status Award Leader ändern",
    "moduleTitle.parent_consent_form": "Einverständniserklärung Eltern/Erziehungsberechtigte",
    "notifications.authorization_contact_has_been_set": "Autorisierungskontakt wurde festgelegt",
    "button.close": "Schliessen",
    "label.independent_country": "Selbstständiger Staat",
    "notifications.aj_preparation_training_has_been_returned": "Vorbereitung und Ausbildung wurde überarbeitet",
    "route.history_log": "Verlauf",
    "participant.account_settings": "Einstellungen Konto",
    "label.bulk_action_error_item": "{globalId} {firstName} {lastName} {email} weil",
    "label.orb_account": "ORB Account",
    "notifications.file_url_is_not_specified_in_configuration": "URL in Konfiguration nicht spezifiziert\n",
    "notifications.award_unit_has_been_removed": "Award Anbieter/ Unabhängiger Award Anbieter wurde entfernt",
    "table.parent": "Eltern",
    "label.mode_of_transport": "Fortbewegunsart",
    "label.parental_consent_email_info": "Vergessen Sie nicht, die Eltern-Email zu überprüfen und die Einwilligung manuell über den Award Detailbildschirm zu senden.",
    "label.current_award": "Aktueller Award",
    "table.action": "Aktion",
    "pageTitle.suboperating_authorities": "Sub-Operating Authorities",
    "notifications.award_leader_has_been_assigned": "Award Leader wurde zugewiesen",
    "tabs.sign_offs_locally": "Lokale Genehmigung",
    "Activity log has been restored": "Benachrichtigung: Nachweis wurde wiederhergestellt",
    "sidebar.naos": "NAOs",
    "tabs.aj_templates": "Vorlagen für Expeditionen",
    "notifications.logging_out": "Ausloggen...",
    "label.update_label": "Label aktualisieren",
    "button.organisation_settings": "Einstellungen Organisation",
    "tabs.independent_award_centers": "Unabhängige Award Anbieter ",
    "label.current": "Aktuell",
    "table.location": "Ort",
    "button.search": "Suchen",
    "notifications.aj_preparation_training_has_been_approved": "Vorbereitung und Ausbildung wurde genehmigt",
    "route.participants": "Teilnehmer*innen",
    "label.other_location_information": "Weitere Angaben zum Ort",
    "label.number_of_records": "Anzahl der Aufzeichnungen",
    "translationsManagement.infoLabel": "Mit dieser Funktion können Übersetzungen von POEditor aktualisiert werden",
    "parentalConsent.i_consent_to_pay_all": "5. Ich erkläre mich damit einverstanden, alle Arzt-, Krankentransport- und/oder Krankenhausgebühren zu zahlen, die mein Kind infolge eines Unfalls, einer Verletzung, Krankheit o.ä. im Rahmen der Teilnahme an oder der An- und Abreise zu Aktivitäten oder Veranstaltungen im Zusammenhang mit dem Award, erleidet, sofern diese nicht über den Programmanbieter gedeckt sind.",
    "label.nationality": "Staatsangehörigkeit (optional)",
    "states.approval": "Genehmigung",
    "notifications.something_went_wrong": "Etwas ist schief gelaufen",
    "aj.practice": "Probe",
    "label.addressLine2": "Adresse zweite Zeile",
    "label.please_leave_a_note": "Bitte hinterlassen Sie eine Notiz",
    "placeholder.select": "Auswählen",
    "label.observations": "Beobachtungen",
    "label.aim": "Ziel",
    "label.addressLine1": "Adresse erste Zeile",
    "roles.aj_instructor": "Expeditionsanleiter*in",
    "meta.payments_waiting": "Zahlungen - Ausstehend",
    "label.award_to_delete": "Zu löschende Stufe des Awards",
    "label.category": " Kategorie",
    "roles.instructor": "Ausbilder*in",
    "moduleTitle.remove_customization_and_reset": "Personalisierung entfernen und Konfigurationswert zurücksetzen?",
    "notifications.participant_registration_has_been_restored": "Anmeldung Teilnehmer*in wurde wiederhergestellt",
    "organisation.change_award_unit_mode": "Organisationsmodus verändern",
    "table.organization_type": "Organisation Typ",
    "notifications.participant_has_been_deleted": "Teilnehmer*in wurde gelöscht",
    "label.language_settings": "Spracheinstellungen",
    "notifications.event_has_been_approved": "Expeditionsveranstaltung wurde genehmigt",
    "label.password": "Passwort",
    "label.text": "Text",
    "table.observations": "Beobachtungen",
    "notifications.participant_has_been_created": "Teilnehmer*in wurde erstellt",
    "table.note_for_al": "Nachricht für Award Leader",
    "label.payment_confirmed": "Zahlung bestätigt",
    "label.previous_completed_award_level": "Vorherige Stufe (nicht ORB)",
    "pageTitle.new_aj_event": "Neue Expeditionsveranstaltung",
    "label.backend": "Backend",
    "label.relationship_to_participant": "Beziehung zu Teilnehmer*in",
    "award.physical_recreation": "Fitness",
    "contact.collect_emails": "Sammeln Sie E-Mail-Adressen für den E-Mail-Versand",
    "moduleTitle.assessor_report_reject": "Bericht Gutachter*in ablehnen",
    "label.supervisor_report": "Bericht Aufsichtsperson",
    "table.role": "Rolle",
    "route.user_guide_web_nao": "Nutzerhandbuch Web - NAO",
    "label.page_not_found": "404 - Seite nicht gefunden",
    "table.labels": "Label ",
    "notifications.file_has_been_uploaded": "Datei wurde hochgeladen",
    "moduleTitle.address": "Adresse",
    "moduleTitle.lead_coordinator": "Hauptkoordinator*in",
    "pageTitle.login": "Login",
    "label.frontoffice": "Frontoffice",
    "participant.would_you_like_to_remove_registration": "Möchten Sie diese Anmeldung löschen?",
    "notifications.rp_has_been_setup": "Gold-Projekt wurde eingerichtet",
    "moduleTitle.award_unit": "Award Anbieter",
    "button.remove_file": "Datei entfernen",
    "moduleTitle.billing_address": "Rechnungsadresse",
    "pageTitle.my_aj_events": "Meine Expeditionsveranstaltungen",
    "route.tasks": "Aufgaben",
    "button.confirm": "Bestätigen",
    "label.national_award_authority": "NAO (Nationales Büro)",
    "label.independent_award_centre": "Unabhängiger Award Anbieter ",
    "award.generate_award_report": "Bericht generieren",
    "route.my_region_office_customization": "Mein regionales Büro - Personalisierung",
    "label.email_help_aj_category": "Kategorie Expedition",
    "label.your_report_has_been_rejected": "Sie haben die Begutachtung ohne Genehmigung zurückgeschickt",
    "notifications.password_change_request_has_been_sent": "Bitte um Zurücksetzen des Passworts wurde versendet",
    "tabs.detail": "Angaben",
    "participant.change_participant_status": "Status Teilnehmer*in ändern",
    "table.key": "Schlüssel",
    "label.find_address": "Adresse finden",
    "notifications.assessor_has_been_rejected": "Gutachter*in wurde überarbeitet",
    "label.transfer_participants": "Teilnehmer*innen übertragen",
    "button.continue_to_payment_gateway": "Weiter zum Zahlungsportal ",
    "notifications.participant_registration_has_been_removed": "Anmeldung Teilnehmer*in entfernt",
    "moduleTitle.page_not_found": "404 - Seite nicht gefunden",
    "route.adventurous_journeys": "Expeditionen",
    "states.registration_assessment": "Bearbeitung Anmeldung",
    "heading.change_award_unit_mode": "Modus Award Anbieter verändern",
    "label.user_guide_web_nao": "Nutzerhandbuch Web - NAO",
    "tabs.silver_level": "Silber Stufe",
    "table.paid_by": "Bezahlt mit",
    "label.your_report_has_been_successfully_sent": "Ihr Bericht wurde versendet.",
    "sidebar.my_organization": "Meine Organisation",
    "pageTitle.participants": "Teilnehmer*innen",
    "notifications.preparation_training_has_been_updated": "Vorbereitung und Ausbildung wurde aktualisiert",
    "moduleTitle.server_is_unreachable": "Server ist nicht erreichbar\n",
    "label.last_activity_date": "Letztes Aktivitätsdatum",
    "award.bronze_level": "Bronze Stufe",
    "moduleTitle.award_units": "Award Anbieter",
    "table.completed": "Abgeschlossen",
    "moduleTitle.revise_message": "Nachricht überarbeiten",
    "table.lastUsed": "Zuletzt verwendet",
    "award.bronze_to_gold_level": "Bronze bis Gold Stufe",
    "button.change_password": "Passwort ändern",
    "label.nao_price": "NAO Preis",
    "label.payment_state": "Zahlungsstatus",
    "label.wwc_expired": "WWC abgelaufen",
    "label.award_office_signoff_date": "Datum Genehmigung  Award Büro",
    "label.award_unit": "Award Anbieter",
    "award.gold_level_short": "Gold",
    "moduleTitle.other_info": "Andere Informationen",
    "table.note": "Nachricht",
    "label.search_by_email_first_or_last": "Nach Email, Vor- oder Nachname suchen",
    "tabs.history": "Verlauf",
    "notifications.label_has_been_created": "Das Label wurde erstellt.",
    "tabs.unassigned_participants": "Nicht zugewiesene Teilnehmende",
    "table.main_award_leader": "Koordinator*in",
    "parentalConsent.i_as_the_parent": "3. Mir ist bekannt, dass bestimmte Aktivitäten als risikoreich gelten und dass risikoreiche Aktivitäten möglicherweise nicht durch die Versicherungen des Programmanbieters abgedeckt sind. Mir ist bekannt, dass die Verantwortung für alle Risiken, die sich aus der Teilnahme des/der Teilnehmer*in am Programm ergeben, ausschliesslich bei dem/der Teilnehmer*in liegt.",
    "label.state": "Status",
    "notifications.award_leader_has_been_removed": "Award Leader wurde entfernt",
    "tabs.organization_detail": "Anbieterangaben",
    "table.operating_authorities": "Operating Authorities",
    "label.available_labels": "Verfügbare Labels",
    "modal.select": "Auswählen",
    "tabs.expired_payments": "Abgelaufene Zahlungen",
    "moduleTitle.note_for_al": "Notiz für Award Leader",
    "moduleTitle.confirm": "Bestätigen",
    "notification.new_activity_added": "Neue Aktivität wurde hinzugefügt",
    "notifications.award_leader_has_been_moved": "Award Leader wurde verschoben",
    "label.award_mode": "Award Modus",
    "label.phone": "Telefonnummer",
    "notifications.organization_has_been_updated": "Organisation wurde aktualisiert",
    "moduleTitle.assessor": "Gutachter*in",
    "label.bulk_action_confirmation": "Bulk Aktion Bestätigung",
    "table.parent_approval": "Einverständnis Eltern",
    "label.date_of_delivery": "Eingangsdatum",
    "sidebar.assessors": "Gutachter*innen",
    "label.journey_activity": "Expeditionsaktivität",
    "award.inactive_award": "Award inaktiv",
    "label.end_date": "Enddatum",
    "label.orb_testing": "ORB Testing",
    "label.no_activities": "Keine Aktivitäten",
    "moduleTitle.please_confirm": "Bitte bestätigen",
    "button.login_with_another_account": "Mit anderem Konto anmelden",
    "tasks.reject_registration": "Anmeldung überarbeiten",
    "label.submitted_after_date": "Eingereicht nach",
    "label.update_translations_successful": "{count} Artikel erfolgreich geändert.",
    "button.assign_leader": "Award Leader zuweisen",
    "table.already_running": "Bereits gestartet",
    "label.no": "Nein",
    "label.count_items_selected": "{count} Elemente ausgewählt",
    "label.secondary_phone_number": "Sekundäre Telefonnummer",
    "label.my_experience": "Meine Erfahrung",
    "notifications.adventurous_journey_has_been_approved": "Expedition wurde genehmigt",
    "pageTitle.mro_detail": "Mein regionales Büro - Angaben",
    "moduleTitle.nao_specific_info": "NAO Informationen",
    "label.preparing_document_for_import": "Dokument für den Import vorbereiten",
    "tasks.observations": "Beobachtungen",
    "notifications.confirmation_email_has_been_sent": "Bestätigungsemail versendet",
    "button.restore": "Wiederherstellen",
    "label.importing_file": "Datei importieren",
    "label.or_dont_agree": "Falls Sie nicht zustimmen, können Sie",
    "moduleTitle.award_leader": "Award Leader",
    "label.me": "(ich)",
    "tabs.sub_global_operating_partners": "Sub-Global Operating Partners",
    "button.export_table": "Tabelle exportieren",
    "organisation.move_award_unit": "Award Anbieter verschieben",
    "label.file_category": "label.file_category",
    "notifications.connecting_to_server": "Verbindung zum Server herstellen...",
    "parentalConsent.i_understand_that_a_and_b": "entfällt",
    "table.reason": "Grund",
    "pageTitle.contacts": "Kontakte",
    "states.award_leader_approval": "Genehmigung Award Leader",
    "meta.payments": "Zahlungen",
    "label.suboperating_authority": "Sub-Operating Partner",
    "route.my_region_office": "Mein regionales Büro",
    "states.registration_not_approved": "Anmeldung nicht genehmigt",
    "label.direct_entrant": "Direkteinstieg Teilnehmer*in",
    "tabs.all_participants": "Alle Teilnehmer*innen",
    "tabs.payment": "Zahlung",
    "label.email_help_activity_name": "Name der Aktivität",
    "title.update_report": "Bericht aktualisieren",
    "label.repeat_new_password": "Neues Passwort wiederholen",
    "label.other_roles": "ORB Profil Seite",
    "logs.hours": "Stunden",
    "notifications.spreadsheet_has_been_imported_successfully": "Tabelle wurde erfolgreich importiert",
    "label.bulk_action_question": "Bulk für die {count} Elemente durchführen?",
    "moduleTitle.personal_details": "Persönliche Angaben",
    "label.bulk_action_emailing": "E-Mail-Adressen der ausgewählten Teilnehmer:innen",
    "route.my_events": "Meine Expeditionsveranstaltungen",
    "button.delete_award": "Award Level löschen",
    "errors.include_both_lower_and_upper_case": "Muss sowohl Klein- als auch Großbuchstaben enthalten",
    "tabs.removed_participant_registrations": "Enfernte Teilnehmer*innenanmeldungen",
    "sidebar.mynao": "Mein NAO (Verein)",
    "tabs.office_details": "Büro Details",
    "label.major": "Schwerpunkt",
    "tabs.documents": "Dokumente",
    "label.new_password": "Neues Passwort",
    "sidebar.adventure_journey": "Expedition",
    "pageTitle.customizations": "Personalisierungen",
    "moduleTitle.assessor_report": "{role} Bericht",
    "label.registration_date": "Anmeldedatum",
    "notifications.training_has_been_added": "Ausbildung wurde hinzugefügt ",
    "aj.qualifying": "Abschluss",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Sie wurden abgemeldet, weil die Sitzung bereits beendet wurde",
    "award.service": "Dienst",
    "notifications.rp_state_has_been_changed": "Status Gold-Projekt hat sich geändert",
    "label.ctest_access": "Zugang zur Testseite",
    "table.created": "Erstellt",
    "tasks.revise_task": "Aufgabe überarbeiten",
    "button.assign": "Zuweisen",
    "button.return": "Überarbeiten",
    "table.status": "Status",
    "button.restore_activity": "Aktivität wiederherstellen",
    "tabs.new_aj_event": "Neue Expedition",
    "roles.if_staff_viewer": "IAF Viewer (International Award Foundation)",
    "notifications.new_template_has_been_created": "Neue Vorlage wurde erstellt",
    "global.something_went_wrong": "Etwas ist schiefgelaufen",
    "table.expire_day": "Ablaufdatum",
    "tabs.history_log": "Verlauf",
    "label.form_of_payment": "Zahlungsart",
    "button.add_training": "Ausbildung hinzufügen",
    "label.par_reg_cust_note": "Auf dieser Registerkarte können Sie Felder personalisieren, die bei der Teilnehmer*innenanmeldung angezeigt werden und sich auf die von Ihnen erfasste Datenmenge auswirken. Bitte wenden Sie sich an Ihr nationales/regionales Büro, wenn Sie Änderungen wünschen.",
    "label.my_qualification": "Meine Qualifikation",
    "button.add_new_profile_question": "Neue Profilfrage hinzufügen",
    "table.operating_authority": "Operating Partner",
    "table.aim": "Thema",
    "table.awards": "Awards",
    "participant.deactivate_account": "Konto deaktivieren",
    "table.organization_name": " Organisation",
    "label.email_help_award_leader_first_name": "Vorname Award Leader",
    "table.date": "Datum",
    "tasks.would_you_like_to_delete": "Wollen Sie diesen Teilnehmenden löschen?",
    "notifications.configuration_value_has_been_updated": "Konfigurationswert wurde aktualisiert",
    "ajTemplates.fill_from_template": "Aus Vorlage ausfüllen",
    "contact.send_test_email": "Test-Email senden",
    "moduleTitle.aj_preparation_and_training": "Vorbereitung und Ausbildung",
    "label.ce_be": "",
    "button.notify_participant": "Zurück an Teilnehmer:in",
    "label.parent_phone": "Telefonnummer Eltern / Erziehungsberechtigte",
    "label.nao_regulations": "Vereins-Regularien",
    "award.skills": "Talente",
    "label.reject_application": "diesen Antrag ablehnen.",
    "leader.delete_account": "Kontakt löschen",
    "table.assign": "Zuweisen",
    "roles.aj_supervisor": "Aufsichtsperson Expedition",
    "label.logout": "Logout",
    "moduleTitle.award_leader_edit": "Award Leader bearbeiten",
    "moduleTitle.training": "Ausbildung",
    "notifications.coordinator_has_been_removed": "Koordinator*in wurde entfernt",
    "tabs.operating_partners": "Operating Partner",
    "moduleTitle.main_award_leader": "Koordinator*in",
    "label.bulk_action_successful": "{count} Elemente wurden erfolgreich geändert.",
    "tasks.clear_email_revision": "",
    "table.preparation": "Vorbereitung",
    "table.delete": "Löschen",
    "label.safeguarding_policy": "Die Kinder- und Jugendschutzrichtlinie des Duke Awards e.V. (einschließlich des Verhaltenskodex)",
    "sidebar.reports": "Berichte",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "Der:die Teilnehmer:in hat bereits einen Schwerpunkt auf einer anderen Award Stufe. Möchten Sie einen weiteren Schwerpunkt hinzufügen?",
    "pageTitle.operating_authorities": "Operating Authorities",
    "label.delete_participant_award_modal_question_detail": "Sind Sie sicher, dass Sie {awardLevel} für Teilnehmer:innen {participantId} löschen möchten?",
    "label.confirmed": "Bestätigt",
    "notifications.invitation_has_been_sent": "Einladung wurde versendet",
    "pageTitle.independent_countries": "Unabhängige Länder",
    "label.assessors_email": "Email Gutachter*in",
    "tasks.approve_assessor_registration": "Anmeldung Gutachter*in genehmigen",
    "table.award_duration": "Dauer der Teilnahme",
    "notifications.organization_has_been_moved": "Organisation wurde verschoben",
    "pageTitle.nao_payment": "Nationales Büro - Bezahlung",
    "participant.history_log": "Verlauf",
    "label.rejected_with_note": "Mit einer Notiz zurückgegeben: \"{note}\"",
    "label.already_running": "Bereits gestartet",
    "button.continue": "Fortsetzen",
    "award.no_data_to_show": "Keine Daten vorhanden",
    "participant.send_email_invitation_again_question": "Email Einladung erneut versenden?",
    "label.reason_for_changing_assessor": "Grund für Wechsel Gutachter*in",
    "button.delete": "Löschen",
    "moduleTitle.requirements_and_conditions": "Anforderungen und Bedingungen",
    "roles.leader": "Award Leader",
    "label.if_download_doesnt": "Wenn der Download nicht automatisch startet, überprüfen Sie die Popup-Einstellungen in Ihrem Browser",
    "dashboard.your_todo_list": "Ihre To Do Liste",
    "notifications.award_unit_has_been_returned": "Award Anbieter wurde überarbeitet",
    "moduleTitle.participant_activities": "Aktivitäten Teilnehmer*in",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Aktive Award Leader",
    "aj.preparation": "Vorbereitung",
    "button.change_state": "Status ändern",
    "label.current_password": "Aktuelles Passwort",
    "pageTitle.global_operating_partners": "Global Operating Partners",
    "moduleTitle.contact_settings": "Einstellungen Kontakte",
    "button.remove_photo": "Foto entfernen",
    "notifications.activity_has_been_setup": "Aktivität wurde gewählt",
    "errors.must_be_more_than": "Muss mehr als {limit} sein",
    "table.goal": "Ziel",
    "notifications.coordinator_has_been_set": "Koordinator*in wurde festgelegt",
    "label.cc": "Cc",
    "label.duration": "Dauer",
    "table.actions": "Aktionen",
    "participant.send_email_invitation_again": "Email Einladung erneut versenden?",
    "moduleTitle.would_you_like_to_remove_participant": "Möchten Sie Anmeldung Teilnehmer*in löschen?",
    "parentalConsent.i_authorise_employees": "4. Ich ermächtige die Mitarbeiter*innen, Angestellten oder Beauftragten des Programmanbieters und alle anderen Personen, die an der Organisation des Programms teilnehmen, beteiligt sind oder dabei helfen, im Falle eines Unfalls, einer Verletzung, einer Krankheit oder eines Verlustes, den der Teilnehmer während der Teilnahme an Aktivitäten oder Veranstaltungen im Zusammenhang mit dem Programm oder auf dem Weg dorthin und zurück erleidet, jede notwendige medizinische Hilfe oder Behandlung zu veranlassen, einschließlich, aber nicht beschränkt auf die Inanspruchnahme von Ärzten, Krankenschwestern oder Krankenhausaufenthalten.",
    "button.reload_page": "Seite neu laden",
    "moduleTitle.update_translations": "Projektübersetzungen aktualisieren",
    "label.report_description": "In den Tabellen unten sind die Spalten 'Enthaltene Felder' und 'Letzte Aktualisierungen' derzeit nur auf Englisch verfügbar. Wir suchen nach Lösungen, um sie in andere Sprachen zu übersetzen.  In der Zwischenzeit bitten wir Sie um Entschuldigung - wir hoffen, dass die Berichtsfunktion weiterhin nützlich für Sie ist.",
    "table.email": "Email",
    "label.new_goal": "Neues Ziel",
    "label.participant_survey_parent": "",
    "errors.invalid_email_address": "Ungültige Emailadresse",
    "pageTitle.new_contact": "Neuer Kontakt",
    "sidebar.gops": "GOPs",
    "button.manage_participants": "Teilnehmende verwalten",
    "errors.invalid_phone_format": "Ungültige Telefonnummer",
    "notifications.login_details_have_been_changed": "Zugangsdaten wurden verändert",
    "moduleTitle.participant_logs": "Nachweise Teilnehmer*in ",
    "label.save": "Speichern",
    "label.frequently_asked_questions": "Häufig gestellte Fragen",
    "label.city": "Stadt",
    "notifications.configuration_value_has_been_reset": "Konfigurationswert wurde zurückgesetzt",
    "states.office_sign_off": "Genehmigung Award Büro",
    "button.save": "Speichern",
    "button.import_data_from_selected_file": "Daten aus der ausgewählten Datei importieren",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Ich verstehe, dass der/die Teilnehmende mit einem bestimmten Programmteil des Awards erst beginnen kann, wenn ich mich davon überzeugt habe, dass ein vom Teilnehmenden nominierte(r) Freiwillige(r) - falls dieser kein Mitglied des Programmanbieters ist - über die entsprechende Erfahrung und/oder Qualifikation verfügt, um diesen Programmteil des Awards als Gutachter*in anzuleiten, zu beaufsichtigen und zu beurteilen.",
    "pageTitle.apiKeys": "API-Schlüssel",
    "label.international_region": "Internationale Region",
    "tabs.levels": "Stufen",
    "tabs.additional_files": "Zusätzliche Dateien",
    "label.continuation_level": "Fortsetzungsstufe",
    "table.adventurous_journey_detail": "Angaben zur Expedition",
    "button.set": "Festlegen",
    "label.i_certify_that_as_the_assessor": "Ich bestätige in meiner Eigenschaft als {role}, dass der/die Teilnehmer*in die Anforderungen erfüllt hat.",
    "table.coordinator": "Koordinator*in",
    "participant.send_confirmation_email_again": "Bestätigungsemail erneut versenden?",
    "table.report": "Bericht",
    "label.update_translations_results": "Aktualisieren Sie die Übersetzungsergebnisse",
    "table.observation_note": "Beobachtungsnotiz",
    "label.view_more": "Mehr sehen",
    "notifications.payment_link_has_been_reset": "Zahlungslink wurde erneut gesendet",
    "table.type": "Art",
    "moduleTitle.updateConfigurationKey": "Konfigurationswert aktualisieren",
    "sidebar.independent_award_centers": "Unabhängige Award Anbieter",
    "table.activity_type": "Art der Aktivität",
    "label.awardMode.online": "Online",
    "table.data_state": "Aktualisierung der letzten Daten",
    "button.generate_report": "Bericht generieren",
    "moduleTitle.assessed_by_award_leader": "Vom Award Leader begutachtet",
    "table.child_protection_number": "Kinderschutznummer (falls anwendbar)",
    "button.bulk_change": "Bulk Änderung",
    "label.send_welcome_email": "Begrüßungs-Email senden",
    "label.award_state": "Status Award",
    "moduleTitle.overview": "Überblick",
    "table.aj_detail": "Angaben zur Expedition",
    "pageTitle.tasks_activity_approvals": "Genehmigung Aktivität",
    "label.section": "Programmteil",
    "route.history": "Verlauf",
    "route.event_participants": "Teilnehmer*innen Expeditionsveranstaltung",
    "participant.account_detail": "Einstellungen Konto",
    "route.dashboard": "Dashboard",
    "table.payments": "Zahlungen",
    "pageTitle.profile": "Profil",
    "organisation.remove_organisation": "Organisation entfernen",
    "pageTitle.my_organization": "Meine Organisation",
    "label.award_leader": "Award Leader",
    "notifications.assessor_has_been_updated": "Gutachter*in wurde aktualisiert",
    "label.participant_personal_reflection": "",
    "button.add_key": "Schlüssel hinzufügen",
    "header.appMotto": "DUKE",
    "table.qualifying": "Abschluss",
    "button.upload": "Hochladen",
    "button.resend": "Erneut senden",
    "label.filename": "Dateiname",
    "label.change_parental_consent": "Elterliche Zustimmung von Papier zu elektronisch",
    "button.cancel": "Widerrufen",
    "label.aply_to_all_langs": "Auf alle Sprachen anwenden",
    "route.customization": "Personalisierung",
    "errors.minimal_duration_is": "Mindestdauer ist 30 Minuten",
    "label.email_help_participant_first_name": "Vorname Teilnehmer:in",
    "label.participant_status": "Status Teilnehmer*in",
    "award.bronze_level_short": "Bronze",
    "label.phone_type": "Art des Anschlusses",
    "global.night": "Nacht",
    "button.adventurous_journey_settings": "Einstellungen Expedition",
    "participant.leader_must_be_selected": "Award Leader muss ausgewählt werden",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "Nutzer*in hat Vorbereitung und Ausbildung hinzugefügt",
    "table.approve": "Genehmigen",
    "label.role_in_organisation": "Rolle in Organisation",
    "states.finished": "Abgeschlossen",
    "label.created": "Erstellt",
    "button.back_to_home": "Zurück zur Startseite",
    "label.options": "Optionen",
    "contact.next_level_invitation": "Einladung zur nächsten Stufe",
    "moduleTitle.activity_detail": "Angabe zur Aktivität",
    "route.section_signoff": "Genehmigung Programmteil",
    "moduleTitle.assign_labels_bulk": "Weisen Sie die ausgewählten Labels den Teilnehmer:innen von ${itemCount} zu.",
    "button.contact_settings": "Einstellungen Kontakt",
    "label.transation_id": "Transaktions-ID (falls anwendbar)",
    "notifications.activity_has_been_updated": "Aktivität wurde aktualisiert",
    "sidebar.awards": "Awards",
    "parentalConsent.images_consent": "Als Eltern/Erziehungsberechtigte erkläre ich mich damit einverstanden, dass Bilder meines Kindes von der International Award Foundation zur Bekanntmachung des Awards verwendet werden. Im Einzelfall wird die Stiftung immer unser gesondertes Einverständnis für ein bestimmtes Bild einholen.",
    "participant.would_you_like_to_delete": "Möchtest du dieses Konto löschen?",
    "roles.user": "Statistisch",
    "label.label": "Label ",
    "label.select_sheet": "",
    "global.no_results": "Keine Ergebnisse",
    "moduleTitle.address_line_2": "Adresse zweite Zeile",
    "states.awaiting_office_sign_off": "Genehmigung Award Büro",
    "moduleTitle.export": "Exportieren",
    "moduleTitle.address_line_1": "Adresse erste Zeile",
    "notifications.participant_has_been_assigned": "Teilnehmer*in wurde zugewiesen",
    "roles.viewer": "Viewer",
    "label.participants_total": "Teilnehmende alle",
    "errors.auth_code_is_no_longer_valid": "Der Autorisierungscode ist nicht mehr gültig - er wurde möglicherweise bereits verwendet oder ist abgelaufen",
    "label.file_is_not_available": "Datei ist nicht verfügbar",
    "button.select_template": "Vorlage auswählen",
    "label.payment": "Zahlung (intern für Programmanbieter)",
    "award.silver_level_short": "Silber",
    "table.participant_id": "ID Teilnehmer:in",
    "text.hours_old": "{hours} Stunden alt",
    "moduleTitle.your_personal_information": "Persönliche Angaben",
    "aj.minimum_date_recommendation": "Mindestdatumsempfehlung für Probeexpedition und {name} ist",
    "label.date_of_payment": "Datum der Zahlung",
    "button.view": "Ansehen",
    "label.create_new_label": "Neues Label erstellen",
    "title.confirmation": "Bestätigung",
    "button.set_participants": "Teilnehmende festlegen",
    "roles.assessor": "Gutachter*in",
    "moduleTitle.coordinator_settings": "Koordinator*in Einstellungen",
    "label.parent_relationship": "Mutter, Vater oder Erziehungsberechtigte(r)",
    "table.nao": "NAO",
    "notifications.email_has_been_sent": "Email wurde versendet",
    "label.email_help_participant_full_name": "Nachname Teilnehmer:in",
    "sidebar.suboperating_authorities": "Weitere Partner",
    "route.award": "Award",
    "label.no_roles": "Keine Rollen",
    "table.files": "Dateien",
    "aj.minimum_date_requirements": "Mindestanforderung für Datum Abschlussexpedition und {name} ist",
    "pageTitle.labels": "Label",
    "label.participant_is_semi_offline": "Teilnehmer*in ist offline",
    "moduleTitle.other_coordinators": "Andere Koordinator*innen",
    "button.updateSelectedLanguage": "Sprache auswählen",
    "tasks.approve_award_registration": "Anmeldung genehmigen",
    "participant.invite_participant_to_next_level": "Teilnehmer*in zur nächsten Stufe einladen?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Awards",
    "warning.award_marked_as_paid": "Achtung: Mindestens eine Award Stufe oder eine Anmeldung wurde bezahlt. Bitte beachten Sie die Richtlinien für Erstattungen, bevor Sie bestätigen.",
    "table.edit": "Überprüfen",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "International Award",
    "moduleTitle.after_assigning_a_role_to_yourself": "Nachdem Sie eine Rolle für sich selbst zugewiesen oder geändert haben, müssen Sie sich erneut anmelden.",
    "label.transaction_id": "Vorgangsnummer (falls anwendbar)",
    "table.suboperating_authority": "Sub-Operating Partner",
    "label.participant_survey": "Teilnehmer:in wird zusätzlich zur anonymisierten Wirkungsbefragung in Deutschland zur Teilnahme an internationalen Umfragen eingeladen.",
    "label.created_by": "Erstellt von",
    "button.send_confirmation_email_again_question": "Bestätigungsemail erneut versenden",
    "label.email_help_award_leader_email": "Award Leader Email",
    "label.name": "Name",
    "tabs.gold_level": "Gold Stufe",
    "pageTitle.award_documents": "Award Dokumente",
    "label.online_payments": "Online-Zahlungen",
    "label.child_protection_number": "Kinderschutznummer (wenn anwendbar)",
    "participant.send_password_recovery_email": "Email zum Zurücksetzen des Passworts versenden?",
    "notifications.new_log_has_been_added": "Neuer Nachweis wurde hinzugefügt",
    "moduleTitle.add_gop_role": "GOP oder Sub-GOP Rolle hinzufügen",
    "label.organization_name": "Name des Anbieters",
    "pageTitle.my_organization_templates": "Meine Organisation - Vorlagen",
    "pageTitle.award_leaders": "Award Leader",
    "label.status": "Status",
    "label.street": "Straße",
    "roles.if_staff_superuser": "IAF \"Super-Nutzer*in\" (International Award Foundation)",
    "table.licence_holder": "Lizenzinhaber*in",
    "label.created_at": "Erstellt im",
    "table.section": "Programmteil",
    "table.system_rights": "Systemrechte",
    "label.iac_type": "IAC Art",
    "label.other": "Anderes",
    "moduleTitle.login": "Login",
    "label.no_data_to_show": "Keine Daten vorhanden",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Die Award-Stufe kann nicht modifiziert werden, wenn Teilnehmer*innen einer Expedition zugewiesen sind.",
    "tabs.waiting_payments": "Auf Zahlung warten",
    "global.supervisor": "Aufsichtsperson",
    "notifications.new_role_has_been_added": "Neue Rolle wurde hinzugefüht",
    "award.silver_level": "Silber Stufe",
    "heading.change_awards_mode": "Modus Award verändern",
    "button.save_changes": "Änderungen speichern",
    "organisation.would_you_like_to_move_award_unit": "Wohin möchten Sie diese Organisation bewegen?",
    "label.fields": "label.fields",
    "label.email_help_organization_name": "Der Name des Award-Zentrums.",
    "pageTitle.mro_related_detail": "Mein regionales Büro - Angaben",
    "table.started_at": "Begonnen bei",
    "parentalConsent.i_consent_to_the_award_unit": "2. Ich bin damit einverstanden, dass der Programmanbieter und alle anderen Personen, auch (ehrenamtliche) Helfer, die an der Organisation des Programms beteiligt sind oder helfen, die Teilnehmer*innen bei Bedarf im Expeditionsteil befördern. Mir ist bekannt, dass der Programmanbieter mich im Voraus darüber informieren wird, wann und wo solche Expeditionen stattfinden werden.\n",
    "logs.minutes": "Minuten",
    "label.total_participants": "Alle Teilnehmer*innen",
    "moduleTitle.contact_info": "Kontaktinformation",
    "table.payment_link": "Link für Zahlung",
    "errors.please_contact_your_local_award_staff": "Bitte wenden Sie sich an Ihren Award Anbieter."
}